import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIHeaderFormContext} from "./header-form-context";

@Component({
    selector: "fui-header-form-context",
    template: "<ng-content></ng-content>",
    providers: [{ provide: FUIFormContext, useClass: FUIHeaderFormContext }],
    standalone: false
})
export class FUIHeaderFormContextComponent {
}
